export default "__VITE_ASSET__mcPAUwas__"